import React from "react";
import styled from "styled-components";

const BackgroundColor = styled.div`
  width: 45px;
  height: 30px;
  background-color: ${props => props.color};
  border-radius: 3px;
`;

function ColorView({ field, entity, onClick }) {
  const { fieldName } = field;
  return <BackgroundColor color={entity[fieldName]} onClick={onClick} />;
}

export default ColorView;
